import React, { useEffect, useState } from 'react';
import { CalendarClock } from 'lucide-react';
import { contestDaysLeft, daysLeftUntil } from '../../lib/contest';

// Live "X days left to enter" countdown. Uses the shared deadline by default,
// or an explicit `deadline` (YYYY-MM-DD) when provided (admin-editable contest).
export function ContestCountdown({ className = '', showIcon = false, deadline = null }) {
  const compute = () => (deadline ? daysLeftUntil(deadline) : contestDaysLeft());
  const [days, setDays] = useState(compute());
  useEffect(() => {
    setDays(compute());
    const t = setInterval(() => setDays(compute()), 60000);
    return () => clearInterval(t);
}, [deadline]);
  const text = days <= 0 ? 'Contest closed' : `${days} day${days === 1 ? '' : 's'} left to enter`;
  return (
    <span className={className} data-testid="contest-countdown">
      {showIcon && <CalendarClock className="w-3.5 h-3.5 inline mr-1 -mt-0.5" />}{text}
    </span>
  );
}

export default ContestCountdown;
